module.exports = __webpack_public_path__ + "img/Cultural_two.c38add01.png";